import { lazy } from 'react';

const _3dView = lazy(() => import('./assets/3d-view.svg?react'));
const ArrowCircle = lazy(() => import('./assets/arrow-circle.svg?react'));
const ArrowDownStrokeBottom = lazy(() => import('./assets/arrow-down-stroke-bottom.svg?react'));
const ArrowLeft = lazy(() => import('./assets/arrow-left.svg?react'));
const ArrowRight = lazy(() => import('./assets/arrow-right.svg?react'));
const ArrowUpRight = lazy(() => import('./assets/arrow-up-right.svg?react'));
const ArrowsCircleDouble = lazy(() => import('./assets/arrows-circle-double.svg?react'));
const BarcodeScan = lazy(() => import('./assets/barcode-scan.svg?react'));
const BoxHalfArrowIn = lazy(() => import('./assets/box-half-arrow-in.svg?react'));
const BoxHalfArrowOut = lazy(() => import('./assets/box-half-arrow-out.svg?react'));
const Calendar = lazy(() => import('./assets/calendar.svg?react'));
const CartHeader = lazy(() => import('./assets/cart-header.svg?react'));
const Cart = lazy(() => import('./assets/cart.svg?react'));
const Check = lazy(() => import('./assets/check.svg?react'));
const ChevronDown = lazy(() => import('./assets/chevron-down.svg?react'));
const ChevronUp = lazy(() => import('./assets/chevron-up.svg?react'));
const CircleCheck = lazy(() => import('./assets/circle-check.svg?react'));
const CircleCross = lazy(() => import('./assets/circle-cross.svg?react'));
const CircleFilled = lazy(() => import('./assets/circle-filled.svg?react'));
const CircleI = lazy(() => import('./assets/circle-i.svg?react'));
const Circle = lazy(() => import('./assets/circle.svg?react'));
const Cross = lazy(() => import('./assets/cross.svg?react'));
const Eye = lazy(() => import('./assets/eye.svg?react'));
const House = lazy(() => import('./assets/house.svg?react'));
const MagnifyingGlass = lazy(() => import('./assets/magnifying-glass.svg?react'));
const Mail = lazy(() => import('./assets/mail.svg?react'));
const Minus = lazy(() => import('./assets/minus.svg?react'));
const PenBox = lazy(() => import('./assets/pen-box.svg?react'));
const Phone = lazy(() => import('./assets/phone.svg?react'));
const PictoAvailability = lazy(() => import('./assets/picto-availability.svg?react'));
const PictoBurnInConditions = lazy(() => import('./assets/picto-burn-in-conditions.svg?react'));
const PictoCharacteristics = lazy(() => import('./assets/picto-characteristics.svg?react'));
const PictoFastDelivery = lazy(() => import('./assets/picto-fast-delivery.svg?react'));
const PictoFastSearch = lazy(() => import('./assets/picto-fast-search.svg?react'));
const PictoFunctionalFeatures = lazy(() => import('./assets/picto-functional-features.svg?react'));
const PictoSecurity = lazy(() => import('./assets/picto-security.svg?react'));
const PictoService = lazy(() => import('./assets/picto-service.svg?react'));
const Plus = lazy(() => import('./assets/plus.svg?react'));
const Share = lazy(() => import('./assets/share.svg?react'));
const SlideControl = lazy(() => import('./assets/slide-control.svg?react'));
const Trashcan = lazy(() => import('./assets/trashcan.svg?react'));
const TriangleExclamationMark = lazy(() => import('./assets/triangle-exclamation-mark.svg?react'));
const UserHeader = lazy(() => import('./assets/user-header.svg?react'));

export const ICON_TYPE_COMPONENT_MAP = {
  '3d-view': _3dView,
  'arrow-circle': ArrowCircle,
  'arrow-down-stroke-bottom': ArrowDownStrokeBottom,
  'arrow-left': ArrowLeft,
  'arrow-right': ArrowRight,
  'arrow-up-right': ArrowUpRight,
  'arrows-circle-double': ArrowsCircleDouble,
  'barcode-scan': BarcodeScan,
  'box-half-arrow-in': BoxHalfArrowIn,
  'box-half-arrow-out': BoxHalfArrowOut,
  calendar: Calendar,
  'cart-header': CartHeader,
  cart: Cart,
  check: Check,
  'chevron-down': ChevronDown,
  'chevron-up': ChevronUp,
  'circle-check': CircleCheck,
  'circle-cross': CircleCross,
  'circle-filled': CircleFilled,
  'circle-i': CircleI,
  circle: Circle,
  cross: Cross,
  eye: Eye,
  house: House,
  'magnifying-glass': MagnifyingGlass,
  mail: Mail,
  minus: Minus,
  'pen-box': PenBox,
  phone: Phone,
  'picto-availability': PictoAvailability,
  'picto-burn-in-conditions': PictoBurnInConditions,
  'picto-characteristics': PictoCharacteristics,
  'picto-fast-delivery': PictoFastDelivery,
  'picto-fast-search': PictoFastSearch,
  'picto-functional-features': PictoFunctionalFeatures,
  'picto-security': PictoSecurity,
  'picto-service': PictoService,
  plus: Plus,
  share: Share,
  'slide-control': SlideControl,
  trashcan: Trashcan,
  'triangle-exclamation-mark': TriangleExclamationMark,
  'user-header': UserHeader,
} as const;

export type IconVariant =
  | '3d-view'
  | 'arrow-circle'
  | 'arrow-down-stroke-bottom'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up-right'
  | 'arrows-circle-double'
  | 'barcode-scan'
  | 'box-half-arrow-in'
  | 'box-half-arrow-out'
  | 'calendar'
  | 'cart-header'
  | 'cart'
  | 'check'
  | 'chevron-down'
  | 'chevron-up'
  | 'circle-check'
  | 'circle-cross'
  | 'circle-filled'
  | 'circle-i'
  | 'circle'
  | 'cross'
  | 'eye'
  | 'house'
  | 'magnifying-glass'
  | 'mail'
  | 'minus'
  | 'pen-box'
  | 'phone'
  | 'picto-availability'
  | 'picto-burn-in-conditions'
  | 'picto-characteristics'
  | 'picto-fast-delivery'
  | 'picto-fast-search'
  | 'picto-functional-features'
  | 'picto-security'
  | 'picto-service'
  | 'plus'
  | 'share'
  | 'slide-control'
  | 'trashcan'
  | 'triangle-exclamation-mark'
  | 'user-header';

/**
 * PictoVariant is a subset of IconVariant that includes only the pictograms.
 * Pictograms are vector graphics that should not be used in arbitrary sizes.
 */
export type PictoVariant = Extract<
  IconVariant,
  | 'picto-availability'
  | 'picto-burn-in-conditions'
  | 'picto-characteristics'
  | 'picto-fast-delivery'
  | 'picto-fast-search'
  | 'picto-functional-features'
  | 'picto-security'
  | 'picto-service'
>;
